import { render, staticRenderFns } from "./invoiceRecord.vue?vue&type=template&id=73f238d7&"
import script from "./invoiceRecord.vue?vue&type=script&lang=js&"
export * from "./invoiceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports